import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7017390c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "px-24 xl:px-64"
}

import { computed } from 'vue';
import { BreadcrumbItemModel } from '@/types/B2BcontentServerContract';
import pageStore from '@/shared/content/page.store';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {

const breadcrumbs = computed(() => {
    return pageStore.breadcrumb || [] as BreadcrumbItemModel[];
});

const jsonLd = computed(() => {
    if (!(breadcrumbs.value?.length)) {
        return null;
    }

    const jsonLdBreadcrumb: any = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [],
    };

    breadcrumbs.value.map((item: BreadcrumbItemModel, index) => {
        jsonLdBreadcrumb.itemListElement.push({
            '@type': 'ListItem',
            position: (index + 1),
            name: item.name,
            item: location.origin + item.url,
        } as any);
    });

    return jsonLdBreadcrumb;
});


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_Transition, { name: "o-anim-fade-300" }, {
    default: _withCtx(() => [
      (_unref(breadcrumbs).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_TransitionGroup, {
              name: "list-fade",
              class: "mt-x4 md:mb-x2 flex items-center flex-wrap",
              tag: "ul"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbs), (crumb, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: crumb.name,
                    class: "c-link o-text-caption flex items-center mr-x1 md:mr-x2"
                  }, [
                    _createVNode(RouterLinkConditional, {
                      class: "o-text-button c-magic-line text-inherit mr-x1 md:mr-x2",
                      to: crumb.url,
                      "spa-enabled": crumb.spaLink,
                      title: crumb.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(crumb.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "spa-enabled", "title"]),
                    (index < _unref(breadcrumbs).length - 1)
                      ? (_openBlock(), _createBlock(_component_c_icon, {
                          key: 0,
                          name: "icon-arrow-small",
                          width: "9",
                          height: "9",
                          class: "-mt-1"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            (_unref(jsonLd))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
                  key: 0,
                  type: "application/ld+json"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(jsonLd)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})